import { GD } from "src/GD";
import { banRuleId, getBanRulesRequest, parseBanRules } from "./banRulesData";
import { positiveId, unwrapAssignmentResponse, type Assignment } from "./trafficAssignmentsData";
import type { RuleRecord } from "./ruleBlocksData";

// The global assignment list needs rule conditions, not editable form models.
// Reuse embedded rules first, then fetch the missing models in list pages.
export const loadAssignmentRules = async (projectId: number, assignments: Assignment[], signal: AbortSignal): Promise<Map<number, RuleRecord>> => {
	signal.throwIfAborted();
	const rules = new Map<number, RuleRecord>();
	const needed = new Set(assignments.map(row => row.rule_id));
	for (const row of assignments) {
		if (row.rule && positiveId(row.rule.id) === row.rule_id && Array.isArray(row.rule.scope)) {
			rules.set(row.rule_id, row.rule);
			needed.delete(row.rule_id);
		}
	}
	const seen = new Set<number>();
	const perPage = 100;
	for (let page = 0; needed.size; page++) {
		signal.throwIfAborted();
		const response = await GD.REQ_API.request({ ...getBanRulesRequest(projectId, page, perPage), signal });
		signal.throwIfAborted();
		const parsed = parseBanRules(unwrapAssignmentResponse(response));
		if (!parsed) throw new Error("invalidResponse");
		for (const rule of parsed.rows) {
			const id = banRuleId(rule);
			if (id === null || seen.has(id)) throw new Error("invalidResponse");
			seen.add(id);
			if (needed.has(id) && Array.isArray(rule.scope)) {
				rules.set(id, rule);
				needed.delete(id);
			}
		}
		const hasNext = parsed.totalPages !== null ? page + 1 < parsed.totalPages : parsed.total !== null ? (page + 1) * perPage < parsed.total : parsed.rows.length >= perPage;
		if (!hasNext) break;
		if (!parsed.rows.length) throw new Error("invalidResponse");
	}
	return rules;
};
